import DragDropChartBox from "../DragDropChartBox";
import m, {Vnode} from "mithril";
import PointDefinition from "../model/PointDefinition";

export default class AvailablePoints {
    constructor(
        private readonly container: DragDropChartBox
    ) { }


    public drop(): void {
        const point = this.container.draggedPoint;
        if (point) {
            point.x = null;
            point.y = null;
        }
    }

    private viewDraggable(point: PointDefinition): Vnode {
        const dragged = point === this.container.draggedPoint;
        return m('.draggable'+(dragged?'.dragged':''), {
            draggable: false,
            onpointerdown: () => this.container.draggedPoint = point,
            ontouchstart: (e: TouchEvent) => e.preventDefault(),
        }, [
            m('img', {
                src: point.imageUrl,
                draggable: false,
            }),
            m('label', {}, this.container.form.questionary.renderText(point.label)),
        ]);
    }

    public view(): Vnode {
        const points = this.container.pointDefinitions.filter(point => !point.isPlaced());


        return m('.AvailableImages', {
                onpointerup: () => this.drop(),
            },
            points.length ?
                points.map(point => this.viewDraggable(point)) :
                m('.empty',  {},  [
                    m('label', {}, m.trust('&nbsp;')),
                    m('.dummy')
                ])
        );
    }

}